<template>
  <layout-quarter bg="/images/photo-5.jpg">
    <template v-slot:nav>
      <navigation :showBack="{ mobile: true, desktop: false }" :showFilter="{ mobile: false, desktop: true }" :showFavourites="false" :showLogout="true" />
    </template>

    <h1 class="heading t-inverse">Favourites</h1>

    <div class="t-center" v-if="likedPropertiesCount === 0">
      <h2>You have no saved properties</h2>
      <p>
        Browse properties and save your favourite ones.
        <br>
        You will be able to review them here.
      </p>
      <router-link class="button" to="/properties">View properties</router-link>
    </div>
    
    <template v-else>
      <div class="button-fixed t-center">
        <router-link class="button" to="/properties/enquire/all">Enquire about all properties</router-link>
      </div>
      <div class="grid">
        <card-favourite v-for="property in likedPropertiesData" :key="property.MLS" :property="property" />
      </div>
    </template>

  </layout-quarter>
</template>

<style scoped lang="scss">
  .heading {
    margin-bottom: 100px;

    @include min-sm {
      margin-top: 90px;
      margin-bottom: 250px;
    }
  }

  .grid {
    width: 100%;
    padding-bottom: 80px;

    @include min-sm {
      display: flex;
      align-content: center;
      flex-wrap: wrap;
    }
  }
</style>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  import { backend } from '@/api';

  import LayoutQuarter from '@/layouts/Quarter';
  import Navigation from '@/components/Navigation';
  import CardFavourite from '@/components/CardFavourite';

  export default {
    name: 'Favourites',

    components: {
      LayoutQuarter,
      Navigation,
      CardFavourite
    },

    props: {

    },

    data: () => ({
      
    }),

    computed: {
      ...mapState([
        'user',
        'likedPropertiesData'
      ]),

      ...mapGetters([
        'likedPropertiesCount'
      ])
    },

    methods: {
      ...mapActions([
        'getLikedPropertiesData'
      ])
    },

    created () {
      if (this.user.likedProperties.length) {
        this.getLikedPropertiesData()
      } else {
        let unwatch = this.$watch('user.authenticated', () => this.getLikedPropertiesData().then(unwatch))
      }
    }
  };
</script>